import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const MenWomenHealthContext = React.createContext();

export const useMenWomenHealthContext = () => useContext(MenWomenHealthContext);

export function MenWomenHealthProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/a19a8dd9-4a84-4f0a-bc95-c9134dea245b').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/4f5529e5-267b-4d12-b168-e8f4a9774b2a')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return <MenWomenHealthContext.Provider value={value}>{children}</MenWomenHealthContext.Provider>;
}
